import { useState, useEffect } from "react";

// useState IS still imported because UrgencyBanner uses it for the countdown
// timer. The main Landing component no longer has any local state.


function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    function getDeadline() {
      const now = new Date();
      // Always 2 days from now at 11:59PM ET
      const deadline = new Date(now);
      deadline.setDate(deadline.getDate() + 2);
      deadline.setHours(23, 59, 0, 0);
      return deadline;
    }

    function update() {
      const now = new Date();
      const deadline = getDeadline();
      const diff = deadline - now;
      if (diff <= 0) { setTimeLeft("00:00:00"); return; }
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      setTimeLeft(`${String(h).padStart(2,"0")}:${String(m).padStart(2,"0")}:${String(s).padStart(2,"0")}`);
    }

    update();
    const timer = setInterval(update, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div style={{
      background: "#1a1a2e", color: "#fff", padding: "10px 20px",
      textAlign: "center", fontSize: 13, fontWeight: 500,
      display: "flex", alignItems: "center", justifyContent: "center",
      gap: 8, flexWrap: "wrap",
    }} className="urgency-banner">
      <span style={{ color: "#f59e0b", fontWeight: 700 }}>🚀 Plans from $7.99/mo</span>
      <span style={{ color: "#94a3b8" }}>—</span>
      <span>Cancel anytime. No long-term commitment.</span>
      <span style={{ color: "#f59e0b", fontWeight: 700, fontFamily: "monospace", fontSize: 14 }}>
        {timeLeft}
      </span>
      <span style={{ color: "#64748b" }}>countdown</span>
    </div>
  );
}

function Ticker() {
  return (
    <div style={{ background: "#3b5bdb", color: "#fff", padding: "10px 0", overflow: "hidden", whiteSpace: "nowrap" }}>
      <div style={{ display: "inline-block", animation: "ticker 30s linear infinite" }}>
        {Array(6).fill("✦ Sellability scores on every topic ✦ PDF chapter outlines in seconds ✦ Smart niche targeting ✦ Save & export your favorites ✦ Cancel any time ✦ Plans from $7.99/mo").map((t, i) => (
          <span key={i} style={{ marginRight: 60, fontSize: 13, fontWeight: 500 }}>{t}</span>
        ))}
      </div>
    </div>
  );
}

function StarRating({ count = 5 }) {
  return (
    <span style={{ color: "#f59e0b", fontSize: 18 }}>
      {"★".repeat(count)}
    </span>
  );
}

export default function Landing({ onGetStarted, onLogin, onPreview }) {
  // Both primary CTAs are pure navigation to /pricing. New users pick a plan
  // there; returning users use the "Sign In" link in the nav.
  const goToPricing = () => { window.location.href = "/pricing"; };

  return (
    <div style={{ minHeight: "100vh", background: "#f7f7f5", fontFamily: "Inter, sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        @keyframes ticker { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        @keyframes fadeUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        .cta-btn:hover { background: #3451c7 !important; transform: translateY(-1px); }
        .feature-card:hover { box-shadow: 0 4px 20px rgba(0,0,0,0.08) !important; }

        /* Mobile: trim the nav so it fits a 380px viewport without wrapping.
           Drop the "by Creatovate" tagline. Hide the Get Started button (it's
           huge in the hero anyway, so it's not lost). Show Guide as a small
           text-only link instead of a button. Tighten Sign In. */
        @media (max-width: 640px) {
          .nav-tag { display: none !important; }
          .nav-getstarted { display: none !important; }
          .nav-guide {
            padding: 6px 8px !important;
            font-size: 13px !important;
          }
          .nav-cta { padding: 7px 12px !important; font-size: 13px !important; }
          .urgency-banner { font-size: 11px !important; padding: 8px 14px !important; }
          .ticker-text { font-size: 11px !important; }
          .hero-section { padding: 48px 20px !important; }
          .hero-subtitle { font-size: 15px !important; margin-bottom: 24px !important; }
          .hero-cta-row .cta-btn,
          .hero-cta-row .preview-btn { width: 100%; padding: 14px 24px !important; font-size: 14px !important; }
          .preview-cards { grid-template-columns: 1fr !important; }
        }
      `}</style>

      <UrgencyBanner />
      <Ticker />

      {/* Nav */}
      <nav style={{ background: "#fff", borderBottom: "1px solid #e8e8e4", padding: "14px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100, gap: 12 }}>
        <button onClick={() => window.scrollTo(0,0)} style={{ background: "none", border: "none", cursor: "pointer", display: "flex", alignItems: "center", gap: 6, padding: 0, minWidth: 0 }}>
          <span style={{ fontSize: 18, fontWeight: 800, color: "#1a1a1a" }}>PDFTopicScout</span>
          <span className="nav-tag" style={{ fontSize: 12, color: "#3b5bdb", fontWeight: 600 }}>by Creatovate</span>
        </button>
        <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
          <button onClick={() => { window.location.href = "/guide"; }} className="nav-guide" style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14, fontWeight: 600, color: "#444", fontFamily: "Inter, sans-serif", padding: "8px 14px" }}>
            Guide
          </button>
          <button onClick={() => { window.location.href = "/pricing"; }} className="cta-btn nav-cta nav-getstarted" style={{
            background: "#3b5bdb", color: "#fff", border: "none", borderRadius: 8,
            padding: "9px 20px", fontWeight: 600, fontSize: 14, cursor: "pointer", transition: "all 0.2s", fontFamily: "Inter, sans-serif",
          }}>
            Get Started
          </button>
          <button onClick={onLogin} className="nav-cta" style={{
            background: "transparent", color: "#555", border: "1px solid #e8e8e4",
            borderRadius: 8, padding: "9px 18px", fontWeight: 600, fontSize: 14, cursor: "pointer", fontFamily: "Inter, sans-serif",
          }}>
            Sign In
          </button>
        </div>
      </nav>

      {/* Hero */}
      <div className="hero-section" style={{ background: "#0f172a", color: "#fff", padding: "80px 24px", textAlign: "center" }}>
        <div style={{ maxWidth: 700, margin: "0 auto", animation: "fadeUp 0.6s ease" }}>
          <div style={{ display: "inline-block", background: "#3b5bdb22", border: "1px solid #3b5bdb55", borderRadius: 20, padding: "4px 14px", fontSize: 12, color: "#93c5fd", fontWeight: 600, marginBottom: 20, letterSpacing: "0.06em", textTransform: "uppercase" }}>
            For PDF creators & digital entrepreneurs
          </div>
          <h1 style={{ fontSize: "clamp(36px, 6vw, 60px)", fontWeight: 900, lineHeight: 1.1, marginBottom: 20, letterSpacing: "-1px" }}>
            Find PDF Topics<br />
            <span style={{ color: "#60a5fa" }}>Worth Selling</span>
          </h1>
          <p className="hero-subtitle" style={{ fontSize: 18, color: "#94a3b8", lineHeight: 1.7, marginBottom: 36, maxWidth: 520, margin: "0 auto 36px" }}>
            Stop guessing what to write. PDFTopicScout scores every topic by virality, competition, and sellability — so you only write PDFs people actually want to buy.
          </p>
          <div className="hero-cta-row" style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <button onClick={goToPricing} className="cta-btn" style={{
              background: "#3b5bdb", color: "#fff", border: "none", borderRadius: 10,
              padding: "16px 36px", fontWeight: 700, fontSize: 16, cursor: "pointer",
              transition: "all 0.2s",
            }}>
              See Plans →
            </button>
            <button onClick={onPreview} className="preview-btn" style={{
              background: "transparent", color: "#94a3b8", border: "1px solid #334155",
              borderRadius: 10, padding: "16px 36px", fontWeight: 600, fontSize: 16, cursor: "pointer",
            }}>
              Preview the tool
            </button>
          </div>
          <p style={{ marginTop: 16, color: "#475569", fontSize: 13 }}>From $7.99/mo · Cancel any time · 7-day refund</p>
        </div>
      </div>

      {/* App preview */}
      <div style={{ background: "#0f172a", padding: "0 24px 80px", textAlign: "center" }}>
        <div style={{ maxWidth: 800, margin: "0 auto", background: "#1e293b", borderRadius: 16, border: "1px solid #334155", overflow: "hidden", boxShadow: "0 24px 60px rgba(0,0,0,0.4)" }}>
          <div style={{ background: "#0d1117", padding: "12px 16px", display: "flex", alignItems: "center", gap: 8, borderBottom: "1px solid #1e293b" }}>
            <div style={{ width: 12, height: 12, borderRadius: "50%", background: "#f43f5e" }} />
            <div style={{ width: 12, height: 12, borderRadius: "50%", background: "#f59e0b" }} />
            <div style={{ width: 12, height: 12, borderRadius: "50%", background: "#22c55e" }} />
            <span style={{ fontSize: 12, color: "#475569", marginLeft: 8 }}>pdftopicscout.creatovate.biz</span>
          </div>
          <div style={{ padding: 24 }}>
            <div className="preview-cards" style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginBottom: 12 }}>
              {[
                { topic: "Passive Income for Teachers", score: 82, virality: "High", competition: "Moderate" },
                { topic: "AI Tools for Freelancers", score: 91, virality: "Explosive", competition: "Low" },
                { topic: "Budget Travel on $50/day", score: 74, virality: "High", competition: "Competitive" },
              ].map((t, i) => (
                <div key={i} style={{ background: "#0d1117", borderRadius: 10, padding: "14px", border: "1px solid #1e293b", textAlign: "left" }}>
                  <div style={{ fontSize: 12, color: "#e2e8f0", fontWeight: 600, marginBottom: 10, lineHeight: 1.4 }}>{t.topic}</div>
                  <div style={{ display: "flex", gap: 6, marginBottom: 10, flexWrap: "wrap" }}>
                    <span style={{ fontSize: 10, background: "#3b5bdb22", color: "#93c5fd", borderRadius: 20, padding: "2px 8px", fontWeight: 600 }}>↑ {t.virality}</span>
                    <span style={{ fontSize: 10, background: "#22c55e22", color: "#86efac", borderRadius: 20, padding: "2px 8px", fontWeight: 600 }}>{t.competition}</span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <span style={{ fontSize: 10, color: "#475569" }}>Sellability</span>
                    <div style={{ background: t.score >= 80 ? "#ecfdf5" : "#fffbeb", border: `1px solid ${t.score >= 80 ? "#a7f3d0" : "#fde68a"}`, borderRadius: 6, padding: "2px 8px" }}>
                      <span style={{ fontSize: 14, fontWeight: 800, color: t.score >= 80 ? "#0a7c4e" : "#b45309" }}>{t.score}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div style={{ background: "#0d1117", borderRadius: 10, padding: "14px", border: "1px solid #1e293b", textAlign: "left" }}>
              <div style={{ fontSize: 11, color: "#3b5bdb", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 8 }}>AI Insight — AI Tools for Freelancers</div>
              <p style={{ fontSize: 12, color: "#94a3b8", lineHeight: 1.6 }}>This topic is exploding right now — every freelancer is scrambling to figure out which AI tools are worth paying for. A PDF that cuts through the noise and gives honest reviews? People will pay for that without thinking twice.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Social proof */}
      <div style={{ background: "#fff", padding: "60px 24px", textAlign: "center" }}>
        <div style={{ maxWidth: 800, margin: "0 auto" }}>
          <StarRating />
          <p style={{ fontSize: 14, color: "#999", marginTop: 8, marginBottom: 40 }}>Loved by digital creators & PDF entrepreneurs</p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 20 }}>
            {[
              { name: "Sarah M.", role: "Digital Creator", text: "I used to spend hours researching topics. PDFTopicScout gives me 20 ideas with scores in seconds. Worth every penny.", stars: 5 },
              { name: "James T.", role: "Side Hustler", text: "The sellability score is a game changer. I only write PDFs that are actually going to sell now.", stars: 5 },
              { name: "Priya K.", role: "Etsy Seller", text: "Made my investment back on the first PDF I wrote using this tool. The outline generator alone is worth it.", stars: 5 },
            ].map((r, i) => (
              <div key={i} className="feature-card" style={{ background: "#f7f7f5", borderRadius: 12, padding: "20px", border: "1px solid #e8e8e4", textAlign: "left", transition: "box-shadow 0.2s" }}>
                <StarRating count={r.stars} />
                <p style={{ fontSize: 14, color: "#444", lineHeight: 1.6, margin: "10px 0 14px" }}>"{r.text}"</p>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#1a1a1a" }}>{r.name}</div>
                <div style={{ fontSize: 12, color: "#999" }}>{r.role}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Features */}
      <div style={{ background: "#f7f7f5", padding: "60px 24px" }}>
        <div style={{ maxWidth: 800, margin: "0 auto" }}>
          <h2 style={{ fontSize: 32, fontWeight: 800, color: "#1a1a1a", textAlign: "center", marginBottom: 8 }}>Why PDFTopicScout</h2>
          <p style={{ textAlign: "center", color: "#999", marginBottom: 40, fontSize: 15 }}>Everything you need to find and validate your next PDF idea</p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 16 }}>
            {[
              { icon: "🎯", title: "Sellability Score", desc: "Every topic scored across 10 dimensions including virality, competition, buyer intent and more." },
              { icon: "🔍", title: "20 Topics Instantly", desc: "Pick a niche or search any topic and get 20 AI-powered ideas in seconds." },
              { icon: "📊", title: "Market Intelligence", desc: "See virality, competition level and target audience before you write a single word." },
              { icon: "📄", title: "PDF Outline Generator", desc: "Turn any topic into a full chapter-by-chapter outline ready to start writing." },
              { icon: "⭐", title: "Save Favorites", desc: "Star your best topics and export them as CSV to plan your content calendar." },
              { icon: "🚀", title: "15 Niche Categories", desc: "From personal finance to sustainability — curated niches with proven buyer demand." },
            ].map((f, i) => (
              <div key={i} className="feature-card" style={{ background: "#fff", borderRadius: 12, padding: "20px", border: "1px solid #e8e8e4", transition: "box-shadow 0.2s" }}>
                <div style={{ fontSize: 28, marginBottom: 10 }}>{f.icon}</div>
                <div style={{ fontSize: 14, fontWeight: 700, color: "#1a1a1a", marginBottom: 6 }}>{f.title}</div>
                <div style={{ fontSize: 13, color: "#666", lineHeight: 1.6 }}>{f.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* How it works */}
      <div style={{ background: "#fff", padding: "60px 24px" }}>
        <div style={{ maxWidth: 600, margin: "0 auto", textAlign: "center" }}>
          <h2 style={{ fontSize: 32, fontWeight: 800, color: "#1a1a1a", marginBottom: 8 }}>How It Works</h2>
          <p style={{ color: "#999", marginBottom: 40, fontSize: 15 }}>Three steps to your next bestselling PDF</p>
          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            {[
              { step: "01", title: "Pick your niche", desc: "Choose from 15 curated categories or type any topic you're curious about." },
              { step: "02", title: "Get 20 scored topics", desc: "Instantly see sellability scores, virality, competition and target audience for each idea." },
              { step: "03", title: "Generate your outline", desc: "Click any topic to get an AI-powered chapter outline and start writing immediately." },
            ].map((s, i) => (
              <div key={i} style={{ display: "flex", gap: 20, alignItems: "flex-start", textAlign: "left", background: "#f7f7f5", borderRadius: 12, padding: "20px", border: "1px solid #e8e8e4" }}>
                <div style={{ fontSize: 24, fontWeight: 900, color: "#3b5bdb", flexShrink: 0, minWidth: 40 }}>{s.step}</div>
                <div>
                  <div style={{ fontSize: 15, fontWeight: 700, color: "#1a1a1a", marginBottom: 4 }}>{s.title}</div>
                  <div style={{ fontSize: 14, color: "#666", lineHeight: 1.6 }}>{s.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Pricing teaser */}
      <div style={{ background: "#0f172a", padding: "60px 24px", textAlign: "center" }}>
        <div style={{ maxWidth: 560, margin: "0 auto" }}>
          <h2 style={{ fontSize: 32, fontWeight: 800, color: "#fff", marginBottom: 8 }}>Simple Pricing</h2>
          <p style={{ color: "#64748b", marginBottom: 36, fontSize: 15 }}>Pick the plan that fits. Cancel anytime.</p>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 28 }} className="preview-cards">
            <div style={{ background: "#1e293b", borderRadius: 14, padding: "22px 18px", border: "1px solid #334155", textAlign: "left" }}>
              <div style={{ fontSize: 11, color: "#94a3b8", fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", marginBottom: 6 }}>Standard</div>
              <div style={{ display: "flex", alignItems: "baseline", gap: 4, marginBottom: 6 }}>
                <span style={{ fontSize: 30, fontWeight: 900, color: "#fff", lineHeight: 1 }}>$7.99</span>
                <span style={{ fontSize: 13, color: "#64748b" }}>/mo</span>
              </div>
              <div style={{ fontSize: 12, color: "#94a3b8", lineHeight: 1.5 }}>50 credits monthly · Topic scoring · PDF outlines</div>
            </div>
            <div style={{ background: "#1e293b", borderRadius: 14, padding: "22px 18px", border: "1px solid #3b5bdb", textAlign: "left", boxShadow: "0 0 30px rgba(59,91,219,0.15)", position: "relative" }}>
              <div style={{ position: "absolute", top: -10, right: 12, background: "#3b5bdb", color: "#fff", fontSize: 9, fontWeight: 800, letterSpacing: "0.04em", padding: "2px 8px", borderRadius: 10, textTransform: "uppercase" }}>
                Popular
              </div>
              <div style={{ fontSize: 11, color: "#93c5fd", fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", marginBottom: 6 }}>⚡ Pro</div>
              <div style={{ display: "flex", alignItems: "baseline", gap: 4, marginBottom: 6 }}>
                <span style={{ fontSize: 30, fontWeight: 900, color: "#fff", lineHeight: 1 }}>$12.99</span>
                <span style={{ fontSize: 13, color: "#64748b" }}>/mo</span>
              </div>
              <div style={{ fontSize: 12, color: "#94a3b8", lineHeight: 1.5 }}>100 credits · Priority queue · Hide low-sellability filter</div>
            </div>
          </div>

          <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" }}>
            <button onClick={goToPricing} className="cta-btn" style={{
              background: "#3b5bdb", color: "#fff", border: "none", borderRadius: 10,
              padding: "14px 28px", fontWeight: 700, fontSize: 15, cursor: "pointer",
              transition: "all 0.2s",
            }}>
              See Plans →
            </button>
          </div>
          <p style={{ marginTop: 16, color: "#475569", fontSize: 12 }}>From $7.99/mo · Cancel any time · 7-day refund</p>
        </div>
      </div>

      {/* Footer */}
      <div style={{ background: "#fff", borderTop: "1px solid #e8e8e4", padding: "20px 28px", textAlign: "center" }}>
        <div style={{ fontSize: 13, color: "#999", marginBottom: 8 }}>
          <strong style={{ color: "#1a1a1a", fontWeight: 700 }}>PDFTopicScout</strong>
          <span style={{ color: "#ccc", margin: "0 6px" }}>by</span>
          <strong style={{ color: "#3b5bdb", fontWeight: 700 }}>Creatovate</strong>
          <span style={{ color: "#ccc", margin: "0 8px" }}>—</span>
          <span style={{ color: "#aaa" }}>We help creators monetize - every way possible</span>
        </div>
        <div style={{ display: "flex", gap: 16, justifyContent: "center" }}>
          <a href="/privacy" onClick={e => { e.preventDefault(); window.location.href="/privacy"; }} style={{ fontSize: 12, color: "#aaa", textDecoration: "none" }} onMouseOver={e=>e.target.style.color="#3b5bdb"} onMouseOut={e=>e.target.style.color="#aaa"}>Privacy Policy</a>
          <span style={{ color: "#ddd" }}>·</span>
          <a href="/terms" onClick={e => { e.preventDefault(); window.location.href="/terms"; }} style={{ fontSize: 12, color: "#aaa", textDecoration: "none" }} onMouseOver={e=>e.target.style.color="#3b5bdb"} onMouseOut={e=>e.target.style.color="#aaa"}>Terms of Service</a>
          <span style={{ color: "#ddd" }}>·</span>
          <a href="mailto:info@creatovate.biz" style={{ fontSize: 12, color: "#aaa", textDecoration: "none" }} onMouseOver={e=>e.target.style.color="#3b5bdb"} onMouseOut={e=>e.target.style.color="#aaa"}>info@creatovate.biz</a>
        </div>
      </div>
    </div>
  );
}
